class ProductForm extends HTMLElement {
    constructor() {
        super();
        if (this.hasChildNodes()) this.init();
    }

    init() {
        this.form = this.querySelector('.js-product-form');
        if (this.form) {
            const idInput = this.form.querySelector('[name="id"]');
            if (idInput) {
                idInput.disabled = false;
            }
            this.cartDrawer = document.querySelector('cart-drawer');
            this.submitBtn = this.querySelector('[name="add"]');

            this.addEventListener('submit', this.handleSubmit.bind(this));

            window.productForm = this;
        }
    }

    /* 
    Hacky solution to make different notes have different names 
    */
    hackFixNotes() {
        const uploadKitContainers = this.querySelectorAll('.uploadkit-uploader');
        uploadKitContainers.forEach((container) => {
            const noteInputEls = container.querySelectorAll('.uploadkit-textarea');
            const firstInput = container.querySelector('input[type="hidden"]');

            if (!firstInput) return;

            const baseName = firstInput.name.split('[')[1].replace(']', '');

            if (noteInputEls.length > 1) {
                const nameWithoutNumber = baseName.replace(/\s*\d+$/, '');

                noteInputEls.forEach((noteInputEl, index) => {
                    noteInputEl.name = `properties[Notes ${nameWithoutNumber} ${index + 1}]`;
                });
            } else {
                noteInputEls[0].name = `properties[Notes ${baseName}]`;
            }
        });
    }

    createFormData() {
        this.hackFixNotes();

        const formData = new FormData(this.form);

        const keys = Array.from(formData.keys());

        //remove item[]quantity that don't have an id (multi product forms)
        keys.forEach((key) => {
            console.log('key:', key);
            if (key.includes(']quantity')) {
                const idKey = key.replace('quantity', 'id');
                if (!formData.has(idKey)) {
                    formData.delete(key);
                }
            }
        });

        let sections = 'cart-icon-bubble';
        if (this.cartDrawer) {
            sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sections);

        return formData;
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
        evt.preventDefault();

        if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

        this.errorMsg = null;
        this.setErrorMsgState();

        // Disable "Add to Cart" button until submission is complete.
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('is-loading');

        const formData = this.createFormData();

        const fetchRequestOpts = {
            method: 'POST',
            headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        };

        try {
            const response = await fetch('/cart/add.js', fetchRequestOpts);
            const data = await response.json();
            const error = typeof data.description === 'string' ? data.description : data.message;

            if (data.status) this.setErrorMsgState(error);

            if (!response.ok) throw new Error(response.status);

            this.dispatchEvent(
                new CustomEvent('on:cart:add', {
                    bubbles: true,
                    detail: {
                        variantId: data.variant_id,
                        sections: data.sections
                    }
                })
            );

            window.location.href = '/cart';
        } catch (error) {
            console.log(error);
            this.dispatchEvent(
                new CustomEvent('on:cart:error', {
                    bubbles: true,
                    detail: {
                        error: this.errorMsg.textContent
                    }
                })
            );
        } finally {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.removeAttribute('aria-disabled');
        }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
        this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
        if (!this.errorMsg) return;

        this.errorMsg.classList.toggle('hidden', !error);
        if (error) this.errorMsg.textContent = error;
    }
}

customElements.define('product-form', ProductForm);
